//
//  app/ClientRoot.tsx
//  TownLIT
//
//  Created by Hossein Sakkaki on 2026-08-19.
//  Last Update by Hossein Sakkaki on 2026-10-19.
//

"use client";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { usePathname } from "next/navigation";
import Script from "next/script";

import store from "../redux/store";
import { persistor } from "../redux/storeConfig";
import { markAuthReady } from "../lib/authBoot";

import AddToHomeScreenPrompt from "../components/pwa/AddToHomeScreenPrompt";
import PWAInstallProvider from "../components/pwa/PWAInstallProvider";

import RootAppShell from "./RootAppShell";

export default function ClientRoot({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  const isWayhoodPage =
    pathname === "/wayhood" || pathname?.startsWith("/wayhood/");

  if (isWayhoodPage) {
    // Official layout needs Redux for its existing Header/Footer.
    // Wayhood itself does not require auth, PersistGate, or RootAppShell.
    return <Provider store={store}>{children}</Provider>;
  }

  return (
    <>
      <Script
        src="https://js.stripe.com/v3"
        strategy="afterInteractive"
        onLoad={() => console.log("[Stripe] v3 loaded")}
        onError={(error) =>
          console.error("[Stripe] v3 failed via next/script", error)
        }
      />

      <PWAInstallProvider>
        <AddToHomeScreenPrompt />

        <Provider store={store}>
          <PersistGate
            loading={null}
            persistor={persistor}
            onBeforeLift={() => markAuthReady()}
          >
            <RootAppShell>{children}</RootAppShell>
          </PersistGate>
        </Provider>
      </PWAInstallProvider>
    </>
  );
}
